<!--
  - Copyright (c) 2021. Catch Bangladesh / BitFlex. All rights reserved.
  -->

<template>

  <div class="flex align-middle">
    <b-row>

      <b-col lg="3">
      </b-col>
      <b-col
          md="4"
          lg="6"
          class="justify-content-center"
      >
        <b-card
            header="Help line"
            title="AstharProtik Contact Details"
            footer="Contact Us at any time"
            class="text-center justify-content-center"
            footer-class="text-muted"
        >
          <b-card-text>
            <b-row class="justify-content-center">
              <b-col class="text-primary text-2xl font-bold">Contact No:</b-col>
              <b-col class="text-primary text-2xl font-bold">01621-760059</b-col>
            </b-row>
            <b-row class=" justify-content-center ">
              <b-col class="space text-primary">E-Mail:</b-col>
              <b-col class="text-primary text-2xl font-bold">support@astharprotik.net</b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col lg="3">
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BCardText, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard, BRow, BCol, BCardText, BButton,
  },
  directives: {
    Ripple,
  },
}
</script>
